import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {type RawApiResponse} from 'api/api.types';
import {
    type FacilityDisplayHours,
    type FacilityFunctionalHours,
} from 'api/facilities/facilities.types';

interface GetWeeklyHoursResponse {
    displayHours: FacilityDisplayHours[];
    displayHoursComments: string;
    displayHoursMatchFunctionalHours: boolean;
    overnightParkingAllowed: boolean;
    functionalHours: FacilityFunctionalHours[];
}

type GetWeeklyHoursRawResponse = RawApiResponse<GetWeeklyHoursResponse>;

/**
 * Gets all of a facility's functional and display hours of operation
 *
 * @param facilityId
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/get_facilities_facility_id_weekly_hours
 * @see '/api/v1/facilities/{facilityId}/weekly-hours/'
 */
const getWeeklyHours = async (facilityId: number) => {
    try {
        const {data} = await spotheroGet<GetWeeklyHoursRawResponse>(
            `facilities/${facilityId}/weekly-hours/`
        );

        return data?.data?.functional_hours;
    } catch (err) {
        sendSentryException(err);

        throw new Error(err.message);
    }
};

export default getWeeklyHours;
